import { PlayerComparisonRepository } from './playerComparisonRepository';
import { bindCompareActions } from './compareActions';
const comparisonLoadSelector = '[data-ndc-matchmaker-comparison-load]';
const comparisonUrlKey = 'ndc-matchmaker-comparison-load';
const comparisonQueryStringKey = 'id';

comparisonLoad($('body'));

function comparisonLoad(scope: JQuery<HTMLElement>) {
    scope.find(comparisonLoadSelector).each((i, e) => {
        const element = $(e);
        const url: string = element.data(comparisonUrlKey).toString();

        reloadComparison(element, url);
    });
}

function reloadOnComparisonChange(comparisonElement: JQuery<HTMLElement>, url: string) {
    PlayerComparisonRepository.setChangeNotification('comparisonPageLoad', () =>
        reloadComparison(comparisonElement, url),
    );
}

function reloadComparison(comparisonElement: JQuery<HTMLElement>, url: string) {
    const comparisonIds = PlayerComparisonRepository.getComparisons();
    const comparisonQueryString = comparisonQueryStringKey + '=' + comparisonIds.join(',');

    $.get(url, comparisonQueryString, (result) => {
        const html = $(result);
        comparisonElement.replaceWith(html);
        bindCompareActions(html);
        reloadOnComparisonChange(html, url);
    });
}
